/**
 * Spannungsabfall auf DC- und AC-Leitungen (Wunsch von Mathias, 11/2026).
 *
 * DC: ΔU = Schleifenlänge · I / (κ · A). Die Schleife ist die ganze
 * Leitungslänge des Strings — Zuleitung hin und zurück, Rückführung,
 * Verlängerungen —, also genau die Länge aus stringleitung.ts. Bezogen auf die
 * Stringspannung im MPP. Grenze 2 %, so wird bei Wania geplant.
 *
 * AC: bei Leistungsfaktor 1 ist ΔU/U = P · L / (κ · A · U²) für drei Phasen
 * (U = Außenleiterspannung) und das Doppelte für eine Phase (Hin- und
 * Rückleiter, U = 230 V).
 *
 * κ ist Kupfer bei 20 °C, 56 m/(Ω·mm²) — so rechnen auch die
 * Auslegungsprogramme der Hersteller. Auf einem heißen Dach ist der Widerstand
 * etwas höher; wer knapp an der Grenze liegt, nimmt den nächsten Querschnitt.
 */
export const KAPPA_KUPFER = 56;
/** Grenze für den DC-Abfall, in Prozent. */
export const DC_GRENZE_PROZENT = 2;
export function dcSpannungsfall(e) {
    if (e.querschnittMm2 <= 0 || e.spannungV <= 0)
        return null;
    const abfallV = (e.schleifeM * e.stromA) / ((e.kappa ?? KAPPA_KUPFER) * e.querschnittMm2);
    const prozent = (abfallV / e.spannungV) * 100;
    return { abfallV, prozent, zulaessig: prozent < (e.grenzeProzent ?? DC_GRENZE_PROZENT) };
}
export function acSpannungsfall(e) {
    if (e.querschnittMm2 <= 0 || e.spannungV <= 0)
        return null;
    const faktor = e.phasen === 1 ? 2 : 1;
    const anteil = (faktor * e.leistungW * e.laengeM) / ((e.kappa ?? KAPPA_KUPFER) * e.querschnittMm2 * e.spannungV ** 2);
    const prozent = anteil * 100;
    return { abfallV: anteil * e.spannungV, prozent, zulaessig: prozent < (e.grenzeProzent ?? 3) };
}
//# sourceMappingURL=spannungsfall.js.map